/**
 * Der Fließtext eines Wissensartikels.
 *
 * ## Warum hier `dangerouslySetInnerHTML` steht
 *
 * Die einzige Stelle im Frontend, die es tut — und deshalb mit
 * Begründung, statt als beiläufige Zeile in einer großen Datei.
 *
 * Der Text kommt aus einem Editor und enthält Auszeichnung. Ihn als
 * Klartext auszugeben hieße, dass jede Überschrift und jede Liste als
 * spitze Klammer auf dem Bildschirm steht — der Artikel wäre unlesbar
 * und die Spalte `inhalt_html` sinnlos.
 *
 * Entschärft wird **beim Schreiben**, nicht beim Anzeigen:
 * `services/wissensartikelInhalt.ts` filtert im Controller, und der
 * Controller ist der einzige Weg in die Spalte. Ein zweiter Filter im
 * Browser würde eine Sicherheit vortäuschen, die er nicht hat — wer die
 * API unmittelbar anspricht, kommt an ihm ohnehin vorbei. Die Grenze
 * gehört dorthin, wo geschrieben wird.
 *
 * Was dort erlaubt ist, steht in derselben Datei. Kein `<img>`: ein Bild
 * aus diesem Haus liegt hinter `/api/medien/...` und verlangt einen
 * Bearer-Token, den ein blankes `<img src>` nicht mitschickt.
 */
interface Props {
  html: string | null | undefined;
  className?: string;
}

export function WissensInhalt({ html, className }: Props) {
  if (!html) {
    return (
      <p className="text-sm italic text-secondary-400">
        Dieser Artikel hat noch keinen Text.
      </p>
    );
  }

  return (
    <div
      className={
        className ??
        'prose-sm max-w-none space-y-3 text-sm leading-relaxed text-secondary-700 ' +
          '[&_a]:text-primary-600 [&_a]:underline ' +
          '[&_h2]:mt-4 [&_h2]:text-base [&_h2]:font-bold [&_h2]:text-secondary-900 ' +
          '[&_h3]:mt-3 [&_h3]:text-sm [&_h3]:font-bold [&_h3]:text-secondary-900 ' +
          '[&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 ' +
          '[&_table]:w-full [&_table]:border-collapse ' +
          '[&_td]:border [&_td]:border-secondary-200 [&_td]:px-2 [&_td]:py-1 ' +
          '[&_th]:border [&_th]:border-secondary-200 [&_th]:bg-secondary-50 [&_th]:px-2 [&_th]:py-1'
      }
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
